
import { uploadExcelFile, uploadFile, createPrintShow } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  //  上传图片列表
  fileList: any[] = []

  // 打印内容图片id
  imgids: string = ''

  //  是否已经上传最大数量图片
  maxpic: boolean = false

  excel: string = ''

  excelId: string = ''

  mobile: string = ''

  remark: string = ''

  loading: boolean = false;

  created() {}

  // 上传excel
  private async uploadExcelFile(event: any) {
    this.loading = true;
    const file = event.target.files[0];
    const form = new FormData();
    form.append('fileData', file);
    form.append('type', '11');
    const res: any = await uploadExcelFile(form);
    this.excel = res.data.data[0].sourceName;
    this.excelId = res.data.data[0].id;
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
    this.loading = false;
  }

  // 上传图片
  private async uploadpic(event: any) {
    this.loading = true;
    const file = [...event.target.files];
    if (this.fileList.length < 5) {
      const uploadlength = 5 - this.fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.fileList = [
          ...this.fileList,
          ...res.data.data.slice(0, uploadlength)
        ];
        if (this.fileList.length === 5) {
          this.maxpic = true;
        }
        this.imgids = this.fileList.map((e) => e.id).join(',');
      } else {
        this.$message.error(res.data.message);
      }
    }
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
    this.loading = false;
  }

  private removefile(index: number) {
    this.fileList.splice(index, 1);
    this.maxpic = false;
  }

  delexcel() {
    this.excel = '';
    this.excelId = '';
  }

  async next() {
    const { productId, materialName } = this.$route.query;
    if (this.mobile === '') {
      this.$message.error('请填写联系方式');
    } else {
      createPrintShow({
        productId,
        mobile: this.mobile,
        materialName,
        size: this.$route.query.size,
        orderNum: this.$route.query.orderNum,
        customizContent: this.imgids,
        excelId: this.excelId,
        remark: this.remark,
        companyId: 1
      });
      this.$router.push('/erial-success');
    }
  }
}
